"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CheckBoxEditor;

var _Checkbox2 = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _CheckBoxOutlineBlank2 = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _Flag2 = _interopRequireDefault(require("@material-ui/icons/Flag"));

var _ThumbUp2 = _interopRequireDefault(require("@material-ui/icons/ThumbUp"));

var _Favorite2 = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _Star2 = _interopRequireDefault(require("@material-ui/icons/Star"));

var _Check2 = _interopRequireDefault(require("@material-ui/icons/Check"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("../propTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

CheckBoxEditor.propTypes = _propTypes.EditorProps;

function CheckBoxEditor(_ref) {
  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange;
  var key = column.key,
      style = column.style;

  var handleChange = function handleChange(event) {
    onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, key, event.target.checked)));
  };

  var checked = row[key];
  (0, _react.useEffect)(function () {
    onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, key, Boolean(!checked))));
  }, []);
  var iconType = {};

  switch (style === null || style === void 0 ? void 0 : style.type) {
    case "checklist":
      iconType = /*#__PURE__*/_react["default"].createElement(_Check2["default"], {
        style: {
          color: style.color
        }
      });
      break;

    case "star":
      iconType = /*#__PURE__*/_react["default"].createElement(_Star2["default"], {
        style: {
          color: style.color
        }
      });
      break;

    case "heart":
      iconType = /*#__PURE__*/_react["default"].createElement(_Favorite2["default"], {
        style: {
          color: style.color
        }
      });
      break;

    case "like":
      iconType = /*#__PURE__*/_react["default"].createElement(_ThumbUp2["default"], {
        style: {
          color: style.color
        }
      });
      break;

    case "flag":
      iconType = /*#__PURE__*/_react["default"].createElement(_Flag2["default"], {
        style: {
          color: style.color
        }
      });
      break;

    default:
      iconType = /*#__PURE__*/_react["default"].createElement(_Check2["default"], {
        style: {
          color: "#2d7ff9"
        }
      });
      break;
  }

  return /*#__PURE__*/_react["default"].createElement(_Checkbox2["default"], {
    color: "primary",
    icon: /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank2["default"], {
      color: "disabled"
    }),
    inputProps: {
      "aria-label": "primary checkbox"
    },
    checkedIcon: iconType ? iconType : /*#__PURE__*/_react["default"].createElement(_Check2["default"], null),
    onChange: handleChange,
    checked: checked,
    size: "small",
    style: {
      padding: "0px 8px",
      marginTop: -2
    }
  });
}